import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';

const NotFound = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const parts = location.pathname.split('/').filter(Boolean);
  const first = parts[0];
  const supported = ['en', 'pt', 'es'];
  const prefix = supported.includes(first) ? `/${first}` : '';

  return (
    <div>
      <div className="section" style={{ marginTop: '80px', minHeight: '60vh' }}>
        <div className="container">
          <h2>{t('notFound.title', { defaultValue: 'Página não encontrada' })}</h2>
          <p>{t('notFound.message', { defaultValue: 'A página que você está procurando não existe.' })}</p>
          <Link to={`${prefix}/`} className="button">
            {t('notFound.goHome', { defaultValue: 'Ir para a página inicial' })}
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
